import { WalkModeRenderOrders } from "@/modes/walk-mode/walk-mode-render-orders";
import type { JSX } from "react";
import { DoubleSide } from "three";
import { MANUAL_BLUR_COLOR } from "./manual-blurring-constants";
import { MANUAL_BLUR_LABEL, ManualBlur } from "./manual-blurring-types";

type ManualBlurPreviewProps = {
  /** The manual blur to preview */
  manualBlur: ManualBlur;
};

/** @returns mesh preview for a single manual blur */
export function ManualBlurPreview({
  manualBlur,
}: ManualBlurPreviewProps): JSX.Element {
  return (
    <mesh
      position={manualBlur.position}
      quaternion={manualBlur.quaternion}
      scale={manualBlur.scale}
      renderOrder={WalkModeRenderOrders.ManualBlurPreview}
      name={MANUAL_BLUR_LABEL}
    >
      <planeGeometry attach="geometry" args={[1, 1]} />
      <meshBasicMaterial
        attach="material"
        color={MANUAL_BLUR_COLOR}
        side={DoubleSide}
        depthTest={false}
      />
    </mesh>
  );
}
